import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditLogListItem } from '@models/resources/audit-log.model';

/**
 * `AuditLogService` gemäß Technisches Konzept §5.9
 * (`AuditHistoryComponent` + Zeile 2823: `getForEntity(type, id)`).
 *
 * Beide konkreten Implementierungen fahren gegen den polymorphen
 * `/api/audit-logs`-Endpunkt (Konzept §4.2.6), gefiltert nach
 * `auditable_type` + `auditable_id`. Im Dummy-Modus kommen die Daten
 * aus `DEMO_AUDIT_LOGS`.
 */
export interface AuditLogService {
  /**
   * Chronologische Audit-Logs zu einer polymorphen Entität.
   * @param auditableType Backend-Class-Basename, z. B. `TransactionRequest`.
   * @param auditableId   Primärschlüssel der Entität.
   */
  getForEntity(
    auditableType: string,
    auditableId: number,
  ): Observable<AuditLogListItem[]>;
}

export const AUDIT_LOG_SERVICE = new InjectionToken<AuditLogService>(
  'AuditLogService',
);
